export const replacersKeys = {
  all: ['replacers'] as const,
}
